import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';

import './CustomerEmail.css';

class CustomerPortalPassword extends Component {
    constructor(props){
        super(props);

        this.state = {
            passwordInput: '',
            customerEmail: ''
        };
        this.handleChange = this.handleChange.bind(this);
        this.logInToPortal = this.logInToPortal.bind(this);
        this.handleKeyPressed = this.handleKeyPressed.bind(this);
    }

    componentWillMount() {
        const userId = localStorage.getItem("user_id");
        if (!userId) {
            this.props.history.push('/signin');
        }
    }

    handleChange(e) {
        this.setState({ [e.target.name]: e.target.value });
    }

    handleKeyPressed(e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            this.logInToPortal();
        }
    }

    logInToPortal() {
        if (this.state.passwordInput !== process.env.REACT_APP_CUSTOMER_SUCCESS_TOOL_PASS) {
            alert('Incorrect password. Please try again.');
        } else {
            localStorage.setItem('password_correct', true);
            this.props.history.push({
                pathname: '/portal/customer-tool'
            });
        }
    } 

    render() {
     
        return (
            <div className="customer-portal">
                <div className="title">Please enter your password</div>
                <input type="password" name="passwordInput" value={ this.state.passwordInput } onKeyPress={ this.handleKeyPressed }  onChange={ this.handleChange } />
                <div className="submit">
                    <button onClick={ this.logInToPortal }>Submit</button>
                </div>
            </div>
        );
    }
}

export default withRouter(CustomerPortalPassword);



// WEBPACK FOOTER //
// ./src/views/customersuccessportal/CustomerPortalPassword.js